// RESONATE_ANALYTICS_WAVE2
import { useEffect } from "react";
import { bootstrapAnalytics } from "@/lib/analyticsAdvanced";

// Mount once at the top of the React tree (in App.js).
// Runs all global listeners exactly once per page-load.
export default function AnalyticsBootstrap() {
  useEffect(() => {
    bootstrapAnalytics();
  }, []);
  return null;
}
